import { styled } from "@mui/material/styles";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box,
} from "@mui/material";

// ==== Base Layout ====
export const StyledDialog = styled(Dialog)({
  "& .MuiPaper-root": {
    borderRadius: "12px",
  },
});

export const StyledDialogTitle = styled(DialogTitle)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "flex-start",
});

export const StyledDialogContent = styled(DialogContent)({});

export const StyledDialogActions = styled(DialogActions)({
  justifyContent: "flex-end",
  padding: "16px",
  gap: "2px",
  borderTop: "1px solid #F3F4F7",
});

export const HeadingText = styled(Typography)({
  fontWeight: 600,
  fontSize: "18px",
  fontFamily: "manrope",
});

export const HeadingWrapper = styled(Box)({
  display: "flex",
  flexDirection: "column",
});

export const ContentText = styled(Typography)({
  fontFamily: "manrope",
  fontSize: "14px",
  fontWeight: 500,
  color: "#48566B",
});

// ==== Default Variant Buttons ====
export const SecondaryButton = styled(Button)(({ bgColor, color }) => ({
  fontFamily: "manrope",
  borderRadius: "6px",
  border: "1px solid #DDE2E9",
  padding: "10px 12px",
  height: "32px",
  textTransform: "none",
  fontWeight: 600,
  backgroundColor: bgColor || "#F3F4F7",
  color: color || "#1B2028",
  fontSize: "13px",
}));


export const PrimaryButton = styled(Button)(({ bgColor, color }) => ({
  fontFamily: "manrope",
  borderRadius: "6px",
  padding: "10px 12px",
  height: "32px",
  textTransform: "none",
  fontWeight: 600,
  fontSize: "13px",
  backgroundColor: bgColor || "#0C53BB",
  color: color || "#FFFFFF",
}));

// ==== Delete Variant Buttons ====
export const DeleteCancelButton = styled(Button)({
  fontFamily: "manrope",
  borderRadius: "6px",
  border: "1px solid #DDE2E9",
  padding: "10px 12px",
  height: "32px",
  textTransform: "none",
  fontWeight: 600,
  backgroundColor: "#F3F4F7",
  color: "#1B2028",
  fontSize: "13px",
});

export const DeleteButton = styled(Button)({
  fontFamily: "manrope",
  borderRadius: "6px",
  padding: "10px 12px",
  height: "32px",
  textTransform: "none",
  fontWeight: 600,
  backgroundColor: "#B31514",
  color: "#FFFFFF",
  fontSize: "13px",
});
